import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["locale"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { Checkbox } from '@atlaskit/checkbox';
import Form, { Field } from '@atlaskit/form';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import Select from '@atlaskit/select';
import TextArea from '@atlaskit/textarea';
import { N500 } from '@atlaskit/theme/colors';
import { messages } from '../messages';
import { IntlProviderWithResolvedMessages } from './IntlProviderWithResolvedMessages';
var FeedbackForm = function FeedbackForm(_ref) {
  var _ref$showTypeField = _ref.showTypeField,
    showTypeField = _ref$showTypeField === void 0 ? true : _ref$showTypeField,
    _ref$showDefaultTextF = _ref.showDefaultTextFields,
    showDefaultTextFields = _ref$showDefaultTextF === void 0 ? true : _ref$showDefaultTextF,
    customContent = _ref.customContent,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    feedbackTitle = _ref.feedbackTitle,
    feedbackTitleDetails = _ref.feedbackTitleDetails,
    feedbackGroupLabels = _ref.feedbackGroupLabels,
    summaryPlaceholder = _ref.summaryPlaceholder,
    canBeContactedLabel = _ref.canBeContactedLabel,
    enrolInResearchLabel = _ref.enrolInResearchLabel,
    submitButtonLabel = _ref.submitButtonLabel,
    cancelButtonLabel = _ref.cancelButtonLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    canBeContacted = _useState2[0],
    setCanBeContacted = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    enrollInResearchGroup = _useState6[0],
    setEnrollInResearchGroup = _useState6[1];
  var _useState7 = useState('empty'),
    _useState8 = _slicedToArray(_useState7, 2),
    type = _useState8[0],
    setType = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitting = _useState10[0],
    setIsSubmitting = _useState10[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isTypeSelected = function isTypeSelected() {
    return type !== 'empty';
  };
  var canShowTextField = isTypeSelected() || !showTypeField;
  var isDisabled = showTypeField ? !isTypeSelected() || !description : !description;
  var getFieldLabels = function getFieldLabels(record) {
    return {
      bug: (record === null || record === void 0 ? void 0 : record.bug.fieldLabel) || formatMessage(messages.formBugLabel),
      comment: (record === null || record === void 0 ? void 0 : record.comment.fieldLabel) || formatMessage(messages.formCommentLabel),
      suggestion: (record === null || record === void 0 ? void 0 : record.suggestion.fieldLabel) || formatMessage(messages.formSuggestionLabel),
      question: (record === null || record === void 0 ? void 0 : record.question.fieldLabel) || formatMessage(messages.formQuestionLabel),
      empty: (record === null || record === void 0 ? void 0 : record.empty.fieldLabel) || formatMessage(messages.formEmptyLabel)
    };
  };
  var getSelectOptions = function getSelectOptions(record) {
    return [{
      label: (record === null || record === void 0 ? void 0 : record.question.selectOptionLabel) || formatMessage(messages.selectionOptionQuestionLabel),
      value: 'question'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.comment.selectOptionLabel) || formatMessage(messages.selectionOptionCommentLabel),
      value: 'comment'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.bug.selectOptionLabel) || formatMessage(messages.selectionOptionBugLabel),
      value: 'bug'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.suggestion.selectOptionLabel) || formatMessage(messages.selectionOptionSuggestionLabel),
      value: 'suggestion'
    }];
  };
  var getDefaultSelectValue = function getDefaultSelectValue(record) {
    return {
      label: (record === null || record === void 0 ? void 0 : record.empty.selectOptionLabel) || formatMessage(messages.selectionOptionDefaultLabel),
      value: 'empty'
    };
  };
  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnOverlayClick: false,
    shouldCloseOnEscapePress: false,
    onClose: onClose,
    testId: "feedbackCollectorModalDialog"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              _context.next = 3;
              return onSubmit({
                canBeContacted: canBeContacted,
                description: description,
                enrollInResearchGroup: enrollInResearchGroup,
                type: type
              });
            case 3:
              setIsSubmitting(false);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))
  }, function (_ref3) {
    var formProps = _ref3.formProps;
    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, feedbackTitle || /*#__PURE__*/React.createElement(FormattedMessage, messages.feedbackTitle)), /*#__PURE__*/React.createElement(Button, {
      style: {
        lineHeight: 'normal'
      },
      spacing: 'none',
      tabIndex: -1,
      onClick: onClose,
      appearance: 'subtle'
    }, /*#__PURE__*/React.createElement(EditorCloseIcon, {
      label: "Close Modal",
      primaryColor: "var(--ds-text-subtle, ".concat(N500, ")")
    }))), /*#__PURE__*/React.createElement(ModalBody, null, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/React.createElement(Select, {
      onChange: function onChange(option) {
        if (!option || option instanceof Array) {
          return;
        }
        setType(option.value);
      },
      menuPortalTarget: document.body,
      styles: {
        menuPortal: function menuPortal(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            zIndex: 9999
          });
        }
      },
      defaultValue: getDefaultSelectValue(feedbackGroupLabels),
      options: getSelectOptions(feedbackGroupLabels)
    }) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : null,
      isRequired: true,
      name: "description"
    }, function (_ref4) {
      var fieldProps = _ref4.fieldProps;
      return /*#__PURE__*/React.createElement(TextArea, _extends({}, fieldProps, {
        name: "foo",
        minimumRows: 6,
        placeholder: summaryPlaceholder || formatMessage(messages.summaryPlaceholder),
        onChange: function onChange(e) {
          return setDescription(e.target.value);
        },
        value: description
      }));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "can-be-contacted"
    }, function (_ref5) {
      var fieldProps = _ref5.fieldProps;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        label: canBeContactedLabel || formatMessage(messages.canBeContactedLabel),
        onChange: function onChange(event) {
          return setCanBeContacted(event.target.checked);
        }
      }));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "enroll-in-research-group"
    }, function (_ref6) {
      var fieldProps = _ref6.fieldProps;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        label: enrolInResearchLabel || formatMessage(messages.enrolInResearchLabel),
        onChange: function onChange(event) {
          return setEnrollInResearchGroup(event.target.checked);
        }
      }));
    }))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      appearance: "subtle",
      onClick: onClose
    }, cancelButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.cancelButtonLabel)), /*#__PURE__*/React.createElement(Button, {
      appearance: "primary",
      type: "submit",
      isDisabled: isSubmitting || isDisabled,
      testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.submitButtonLabel))));
  }));
};
var FeedbackFormWithIntl = function FeedbackFormWithIntl(_ref7) {
  var locale = _ref7.locale,
    props = _objectWithoutProperties(_ref7, _excluded);
  return /*#__PURE__*/React.createElement(IntlProviderWithResolvedMessages, {
    locale: locale
  }, /*#__PURE__*/React.createElement(FeedbackForm, props));
};
export default FeedbackFormWithIntl;